import { styled } from 'styled-components';

/** Component that renders a button with minimal styling.
 *  Useful when you need the button onClick functionality but without any visual changes.
 */
export const NoStyleButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;
